import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#15AC77" } = props;
  return (
    <svg width= {width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_14_18460)">
    <path d="M4.16602 10.0002L8.33268 14.1668L16.666 5.8335" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_14_18460">
    <rect width="20" height="20" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  );
}

export default SvgComponent;
